const KEYS = [
  ["driver", "Driver"], ["construction", "Construction Worker"], ["nurse", "Nurse"], ["hotel", "Hotel Staff"],
  ["security", "Security Guard"], ["cleaner", "Cleaner"], ["electrician", "Electrician"], ["plumber", "Plumber"],
  ["welder", "Welder"], ["cook", "Cook / Chef"], ["waiter", "Waiter"], ["housemaid", "Housemaid"],
  ["warehouse", "Warehouse Worker"], ["delivery", "Delivery Rider"], ["factory", "Factory Worker"], ["mason", "Mason"],
  ["carpenter", "Carpenter"], ["painter", "Painter"], ["ac_technician", "AC Technician"], ["mechanic", "Mechanic"],
  ["salesman", "Salesman"], ["cashier", "Cashier"], ["office", "Office Assistant"], ["accountant", "Accountant"],
  ["farm", "Farm Worker"], ["gardener", "Gardener"], ["barber", "Barber"], ["tailor", "Tailor"],
  ["crane_operator", "Crane Operator"], ["caregiver", "Caregiver"],
];

export const JOB_PHOTOS = KEYS.map(([key, label]) => ({ key, label, src: `/jobs/${key}.jpg` }));
export const jobPhotoSrc = (key) => (key ? `/jobs/${key}.jpg` : "/jobs/construction.jpg");
